import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "size", "icon", "iconPosition", "isUppercase", "color", "backgroundColor", "borderColor"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { cloneElement } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './base-tag.p.module.css.js';
var SIZE_STYLES = {
  xs: styles.sizeXs,
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var ICON_POSITION_STYLES = {
  left: styles.alignIconLeft,
  right: styles.alignIconRight
};
var BaseTag = /*#__PURE__*/React.forwardRef( // eslint-disable-next-line complexity
function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      isUppercase = _ref.isUppercase,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var withIcon = /*#__PURE__*/React.isValidElement(icon);
  var iconSlot = withIcon && /*#__PURE__*/cloneElement(icon, {
    className: cn(icon.props.className, styles.icon)
  });
  return /*#__PURE__*/React.createElement("span", _objectSpread(_objectSpread({
    "data-test": 'tag'
  }, restProps), {}, {
    ref: ref,
    className: cn(styles.main, SIZE_STYLES[size], ICON_POSITION_STYLES[iconPosition], withIcon && styles.withIcon, isUppercase && styles.uppercase, className),
    style: {
      color: color,
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }
  }), iconSlot, children);
});
BaseTag.displayName = 'BaseTag';
BaseTag.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  isUppercase: PropTypes.bool,
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string
};
export { BaseTag };
